const getters = {
  experience: state => state.experience,
  describes: state => state.describes,
  primaryGoal: state => state.primaryGoal,
  isSubscribe: state => state.isSubscribe,
  currentStep: state => state.currentStep,
  totalTime: state => {
    const totalTime = state.experience.time + state.describes.time + state.primaryGoal.time + state.isSubscribe.time;
    return totalTime;
  },
  dataSubmit: state => {
    const data = {
      "user_level": state.experience.data,
      "user_type": state.describes.data,
      "user_type_detail": state.describes.specifyValue,
      "shop_industry": state.describes.industry,
      "user_primary_goal": state.primaryGoal.data,
      "user_primary_goal_detail": state.primaryGoal.specifyValue,
      "onboarding_completion_time":state.totalTime,
      "unsubscribed_newsletters": !state.isSubscribe.data,
      "unsubscribed_partners": !state.isSubscribe.data
    }
    return data;
  },
  dataSubcribeSubmit: state => {
    const data = {
      "unsubscribed_newsletters": !state.isSubscribe.data,
      "unsubscribed_partners": !state.isSubscribe.data
    }
    return data;
  }
};

export default getters;
